import React from 'react';
import EventEmitter from 'events';

import Api from '../tools/api';
import util from '../tools/util';

let g_planList;

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
export function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
export function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function _subscribe(callback: any) {
  addChangeListener(callback);
  return () => {
    removeChangeListener(callback);
  };
}
function init(done) {
  done?.();
}
export function isReady() {
  return g_planList?.length > 0;
}
export function getPlan(plan_id: string) {
  return g_planList?.find?.((p) => p.plan_id === plan_id);
}
function _getPlanList() {
  return g_planList;
}
export function usePlan(plan_id: string) {
  const _get = React.useCallback(() => getPlan(plan_id), [plan_id]);
  return React.useSyncExternalStore(_subscribe, _get);
}
export function usePlanList() {
  return React.useSyncExternalStore(_subscribe, _getPlanList);
}
export const fetch = util.herd((done?: (err?: any) => void) => {
  const opts = { url: '/api/1/plan', retry: true };
  Api.get(opts, (err, body) => {
    if (err) {
      util.errorLog('PlanStore.fetch: err:', err);
    } else if (!util.deepEqual(g_planList, body?.plan_list)) {
      g_planList = body?.plan_list;
      _emit('change');
    }
    done?.(err);
  });
});
export default {
  addChangeListener,
  removeChangeListener,
  init,
  isReady,
  getPlan,
  usePlan,
  usePlanList,
  fetch,
};
